import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { MobileNavBarTab } from "./mobile-nav-bar-tab";

interface MobileNavBarTabsProps {
  handleClick: () => void;
}

export const MobileNavBarTabs: React.FC<MobileNavBarTabsProps> = ({
  handleClick,
}) => {
  const { isAuthenticated } = useAuth0();

  return (
    <div className="mobile-nav-bar__tabs">
      {isAuthenticated ? (
        <MobileNavBarTab
          path="/dashboard"
          label="Dashboard"
          handleClick={handleClick}
        />
      ) : (
        <MobileNavBarTab
          path="/"
          label="Home"
          handleClick={handleClick}
        />
      )}
      {isAuthenticated && (
        <MobileNavBarTab
          path="/documents"
          label="My documents"
          handleClick={handleClick}
        />
      )}
      <MobileNavBarTab
        path="/freebie-downloadables"
        label="Freebie downloadables"
        handleClick={handleClick}
      />
      <MobileNavBarTab
        path="/pricing"
        label="Pricing"
        handleClick={handleClick}
      />
      <MobileNavBarTab
        path="/about"
        label="About us"
        handleClick={handleClick}
      />
      {isAuthenticated && (
        <MobileNavBarTab
          path="/profile"
          label="Profile"
          handleClick={handleClick}
        />
      )}
    </div>
  );
};
